import { http } from '../../../utils';
const controller = 'service-desk/object-types';
export const getObjTypes = async (page, pageSize, orderBy, searchCondition) => {
    return await http.get(controller, {
        params: {
            searchCondition,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getObjType = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addObjType = async (ObjType) => {
    return http.post(controller, ObjType);
};
export const updateObjType = async (id, ObjType) => {
    return await http.put(`${controller}/${id}`, ObjType);
};
export const deleteObjType = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getObjTypesDropdown = async () => {
    return await http.get(`${controller}/dropdown`);
};
